//src//components//kalon_method//StrengthPillar.jsx
import { useState } from "react";
import Pillar2Image1 from "../../assets/Pillars/P2_strength1.jpg";
import Pillar2Image2 from "../../assets/Pillars/P2_strength2.jpg";
import Pillar2Image3 from "../../assets/Pillars/P2_strength3.jpg";

export default function StrengthPillar() {
  const images = [Pillar2Image1, Pillar2Image2, Pillar2Image3];
  const [frontIndex, setFrontIndex] = useState(0);

  const handleClick = (idx) => setFrontIndex(idx);

  return (
    <section
      id="strength"
      className="relative w-full py-20 px-6 md:px-12 bg-gradient-to-b from-black/20 to-black/10 overflow-hidden"
    >
      {/* Decorative large number */}
      <div className="absolute -left-8 -top-10 text-[12rem] font-bold text-white/5 select-none pointer-events-none">
        2
      </div>

      {/* Section Heading */}
      <div className="relative max-w-7xl mx-auto flex flex-col md:flex-row-reverse items-center gap-12 mb-16">
        <div className="md:w-1/2 space-y-6 text-center md:text-left">
          <h2 className="text-white text-4xl sm:text-5xl md:text-8xl font-extrabold drop-shadow-lg">
            Pillar 2: Strength & Aesthetics
          </h2>
          <p className="text-neonTurquoise text-lg sm:text-xl md:text-3xl font-semibold drop-shadow-md">
            Build Muscle. Build Confidence. Build Presence.
          </p>
          <p className="text-gray-300 text-base sm:text-lg md:text-2xl max-w-xl drop-shadow-sm">
            Strength training sculpts a lean, athletic physique. Symmetrical, powerful muscle built for performance, aesthetics, and real-world functionality.
          </p>
        </div>

        {/* Interactive Image Cluster */}
        <div className="md:w-1/2 relative flex justify-center items-center">
          <div className="relative w-full h-[28rem] md:h-[32rem]">
            {images.map((img, idx) => {
  const offset = frontIndex - idx; // Reversed offset for right shuffle
  const zIndex = idx === frontIndex ? 20 : 10 - Math.abs(offset);
  const rotate = idx === frontIndex ? 0 : offset * 5; // rotate side images
  const left = 50 + offset * 6; // horizontal offset
  const top = Math.abs(offset) * 2; // slight vertical offset

  return (
    <img
      key={idx}
      src={img}
      alt={`Strength ${idx + 1}`}
      onClick={() => handleClick(idx)}
      className={`absolute w-4/5 h-full object-cover rounded-3xl shadow-2xl cursor-pointer transform transition-all duration-500`}
      style={{
        zIndex,
        transform: `translate(-50%, ${top}%) rotate(${rotate}deg)`,
        left: `${left}%`,
      }}
    />
  );
})}

          </div>
        </div>
      </div>

      {/* Training & Outcomes */}
      <div className="relative max-w-7xl mx-auto flex flex-col md:flex-row items-start gap-8">
        {/* Training Methods */}
        <div className="relative md:w-1/2 bg-gradient-to-br from-cyan-500/20 to-black/30 backdrop-blur-lg rounded-2xl p-10 shadow-2xl hover:shadow-3xl transition duration-500 group overflow-hidden flex flex-col">
          <h3 className="text-white text-3xl font-bold mb-6">
            Training Methods
          </h3>
          <div className="flex-1 overflow-y-auto">
            <ul className="text-gray-200 text-xl space-y-3 pr-2">
              {[
                "Master fundamental lifts: squat, deadlift, and press variations.",
                "Gym protocols for muscle symmetry and aesthetic sculpting.",
                "Dynamic lifts: hang cleans, push press for explosiveness.",
                "Competition prep for peak strength and aesthetic conditioning.",
              ].map((item, idx) => (
                <li
                  key={idx}
                  className="flex items-start gap-3 relative group-hover:text-gray-300 transition duration-500"
                >
                  <span className="text-neonTurquoise font-bold text-3xl mt-0">•</span>{" "}
                  {item}
                </li>
              ))}
            </ul>
          </div>
          {/* Decorative floating circle */}
          <div className="absolute -top-6 -right-6 w-16 h-16 border-2 border-cyan-400 rounded-full opacity-20 animate-pulse-slow"></div>
        </div>

        {/* Connector arrow/line */}
        <div className="hidden md:flex flex-col justify-center items-center">
          <div className="w-12 h-1 bg-gradient-to-r from-cyan-400 to-purple-400 rounded-full animate-pulse-slow"></div>
          <div className="w-4 h-4 mt-2 bg-neonTurquoise rounded-full animate-bounce"></div>
        </div>

        {/* Outcomes */}
        <div className="relative md:w-1/2 bg-gradient-to-br from-cyan-500/30 to-black/30 backdrop-blur-lg rounded-2xl p-10 shadow-2xl hover:shadow-3xl transition duration-500 group overflow-hidden flex flex-col">
          <h3 className="text-white text-3xl font-bold mb-6">Your Outcomes</h3>
          <div className="flex-1 overflow-y-auto">
            <ul className="text-gray-200 text-xl space-y-4 pr-2">
              {[
                "Physical: Lean, symmetrical muscle for performance and aesthetics.",
                "Mental: Confidence, discipline, and perseverance in training.",
                "Who it's for: Athletes, professionals, and beginners seeking physique and strength.",
              ].map((item, idx) => (
                <li
                  key={idx}
                  className="flex items-start gap-3 relative group-hover:text-gray-300 transition duration-500"
                >
                  <span className="text-neonTurquoise font-bold text-3xl mt-0">•</span>{" "}
                  {item}
                </li>
              ))}
            </ul>
          </div>
          {/* Decorative floating circle */}
          <div className="absolute -bottom-6 -left-6 w-16 h-16 border-2 border-purple-400 rounded-full opacity-20 animate-pulse-slow"></div>
        </div>
      </div>
    </section>
  );
}
